(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["metamall-weekend-sale-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-weekend-sale-countdown]';

    const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

    const writeValue = (root, name, value) => {
      const node = root.querySelector('[data-wsc-' + name + ']');
      if (node) node.textContent = pad(value);
    };

    const renderCountdown = (root) => {
      const endAt = Date.parse(root.dataset.endAt || '');
      const remaining = Number.isFinite(endAt) ? Math.max(0, endAt - Date.now()) : 0;
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      writeValue(root, 'days', days);
      writeValue(root, 'hours', hours);
      writeValue(root, 'minutes', minutes);
      writeValue(root, 'seconds', seconds);
      return remaining;
    };

    const copyText = (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      return new Promise((resolve, reject) => {
        try {
          document.execCommand('copy') ? resolve() : reject(new Error('Copy failed'));
        } catch (error) {
          reject(error);
        } finally {
          textarea.remove();
        }
      });
    };

    const init = (root) => {
      if (!root || root.dataset.wscReady === 'true') return;
      root.dataset.wscReady = 'true';

      const tick = () => {
        const remaining = renderCountdown(root);
        if (remaining <= 0 && root._wscTimer) {
          window.clearInterval(root._wscTimer);
          root._wscTimer = null;
        }
        return remaining;
      };

      const startCountdown = () => {
        const remaining = tick();
        if (remaining > 0 && !root._wscTimer) {
          root._wscTimer = window.setInterval(tick, 1000);
        }
      };

      if ('requestAnimationFrame' in window) {
        window.requestAnimationFrame(startCountdown);
      } else {
        window.setTimeout(startCountdown, 0);
      }

      const button = root.querySelector('[data-wsc-copy]');
      if (!button) return;

      const initialLabel = root.dataset.copyLabel || button.textContent.trim();
      const copiedLabel = root.dataset.copiedLabel || initialLabel;

      button.addEventListener('click', () => {
        const code = root.dataset.code || '';
        if (!code) return;

        copyText(code)
          .then(() => {
            button.textContent = copiedLabel;
            window.setTimeout(() => {
              button.textContent = initialLabel;
            }, 1800);
          })
          .catch(() => {
            button.textContent = code;
            window.setTimeout(() => {
              button.textContent = initialLabel;
            }, 1800);
          });
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches && event.target.matches(selector)) init(event.target);
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbar"] && !Shopify.designMode) return;
  try {
    
  const initTopbarTextCarousel = (root = document) => {
    root.querySelectorAll('[data-topbar-text-carousel]').forEach((carousel) => {
      const items = Array.from(carousel.querySelectorAll('.topbar__text-carousel-item'));
      const speed = Number(carousel.dataset.speed) * 1000;

      if (carousel.topbarTextCarouselInterval) {
        clearInterval(carousel.topbarTextCarouselInterval);
      }

      items.forEach((item, index) => item.classList.toggle('is-active', index === 0));

      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      let activeIndex = 0;
      carousel.topbarTextCarouselInterval = setInterval(() => {
        items[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % items.length;
        items[activeIndex].classList.add('is-active');
      }, speed);
    });
  };

  initTopbarTextCarousel();

  document.addEventListener('shopify:section:load', (event) => {
    initTopbarTextCarousel(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
